import { useEffect, useState } from "react";
import { Badge, Spinner } from "react-bootstrap";
import api from "@/api/api.js";

const fmt = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
};

const daysUntil = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return Math.ceil((d.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
};

const SignatureStatus = ({ companyId, refreshKey }) => {
  const [signature, setSignature] = useState(null);
  const [loading, setLoading] = useState(true);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api
      .get(`/companies/${companyId}/digitalSignature/latest`)
      .then(({ data }) => {
        if (active) {
          setSignature(data);
          setMissing(false);
        }
      })
      .catch(() => {
        if (active) setMissing(true);
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [companyId, refreshKey]);

  if (loading) {
    return (
      <div className="text-muted">
        <Spinner animation="border" size="sm" className="me-2" />
        Cargando firma electrónica...
      </div>
    );
  }

  if (missing || !signature) {
    return (
      <div className="text-muted">
        <i className="bi bi-exclamation-circle me-1" />
        No hay firma electrónica (FIEL) registrada.
      </div>
    );
  }

  const days = daysUntil(signature.validTo);
  const expiringSoon = !signature.isExpired && days !== null && days <= 30;

  return (
    <div>
      <div className="d-flex align-items-center gap-2 mb-2">
        {signature.isExpired ? (
          <Badge bg="danger">Expirada</Badge>
        ) : expiringSoon ? (
          <Badge bg="warning" text="dark">
            Por expirar
          </Badge>
        ) : (
          <Badge bg="success">Vigente</Badge>
        )}
        {!signature.isExpired && days !== null && (
          <small className="text-muted">
            {days <= 0
              ? "expira hoy"
              : `${days} día${days === 1 ? "" : "s"} restantes`}
          </small>
        )}
      </div>
      <div className="row g-2">
        <div className="col-sm-6">
          <small className="text-muted d-block">Vigente desde</small>
          <span>{fmt(signature.validFrom)}</span>
        </div>
        <div className="col-sm-6">
          <small className="text-muted d-block">Expira el</small>
          <span className={signature.isExpired ? "text-danger fw-bold" : ""}>
            {fmt(signature.validTo)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SignatureStatus;
